<!-- <img #imageRef [src]="img" (load)="mainImageLoaded()" crossorigin="anonymous"> -->
<div class="LogoContainer">
  @if (mobileLogo()) {
    <img class="RetailerLogo MobileLogo" [src]="mobileLogo()" alt="Customer Logo">
  }
  @if (isSharing() && logo()) {
    <img class="RetailerLogo DesktopLogo" [src]="logo()!" alt="Customer Logo">
  }
</div>
<img #printImg class="PrintImage">
<canvas #imgCanvas class="ImageCanvas" [class.Point]="isRingHovered()" (mousedown)="isComparing() && imageCanvasMouseDown()" (mousemove)="isComparing() && imageCanvasMouseMove()" (mouseup)="isComparing() && imageCanvasMouseUp($event)"></canvas>
@if(!isSharing()) {
  <canvas #interactiveOverlay class="OverlayCanvas"></canvas>
  <!-- FoldedVertical is mirrored onto the CONTAINER, not just the card button, because the Remove and
       View Examples wrappers are SIBLINGS of the card -- they can never see a class set on the button
       (ADO #8909). -->
  <div #controlOverlay class="OverlayControls" [class.Stacked]="cardMode() === 'Stacked'" [class.FoldedVertical]="cardMode() === 'FoldedVertical'">
    @for (control of controls; track $index) {
      <div class="ButtonContainer">
        <button #overlayButton mat-button class="OverlayButton LabelButton" style="--normal-card-width: 130px; --normal-card-height: 81px; --vfold-card-width: 208px; --vfold-card-height: 36px; --hfold-card-width: 80px; --hfold-card-height: 56px;" [class.FoldedVertical]="cardMode() === 'FoldedVertical'" [class.FoldedHorizontal]="cardMode() === 'FoldedHorizontal'" [class.EmptyValue]="getConfiguredItemValue(control.key) === 'Click to Add'" [ngStyle]="getControlStyle(control)" [name]="control.key" (mouseenter)="overlayButtonHover(control.displayName)" (mouseleave)="overlayButtonHover(null)" [class.Hovered]="control.displayName === controlLabelToStyleHovered()" [class.Active]="control.isActive" (click)="overlayButtonClick(control.displayName)" [class.Hidden]="control.isHidden">
          <div class="Flexbox Flexbox--column ButtonContent Label--left">
            <span class="TopSlanty Flexbox">
              <div class="TitleHolder Flexbox Align--center Justify--space-between">
                <span>@if(control.displayName === 'Edge Material') { {{ getEdgeMaterialName() }} } @else { {{ control.displayName }} }</span>
                @let systemChange = getSystemChange(control.key);
                @if (systemChange) {
                  <div class="SystemChangeIndicatorContainer Flexbox Align--center">
                    <mat-icon class="SystemChangeIndicator mat-serious-background">priority_high</mat-icon>
                    <div #changeHoverExplanation class="ChangeHoverExplanation">
                      <div class="Pointy"></div>
                      <div class="ExplanationText Flexbox Flexbox--column Justify--center Gap--tiny">
                        <p>Nearest match</p>
                        <div class="Flexbox Flexbox--column Gap--tiny">
                          <p class="Value">{{ systemChange.oldValue?.displayName ?? 'None' }}</p>
                            <p class="DownArrow">↓</p>
                          <p class="Value">{{ systemChange.newValue?.displayName ?? 'None' }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </span>
            <!-- <span class="MiddleBorder"></span> -->
            @let value = getConfiguredItemValue(control.key);
            @let valueLength = getValueLength(value);
            <span class="ValueLabel Flexbox Align--center Gap--tiny" [class.ShortText]="valueLength < 15" [ngStyle]="getStyle(control.key)">
              @if (value === 'Click to Add') {
                <mat-icon class="Plus ThemeColorPrimary">add_circle</mat-icon>
              }

              @if (control.key === 'gemstones' && value !== 'Click to Add') {
                @if (cardMode() === 'FoldedVertical') {
                  <!-- Collapsed: values side by side as columns on one line (ADO #8909). -->
                  @for (v of value; track $index) {
                    <span class="GemstoneValue">{{ v }}</span>
                  }
                } @else {
                  <!-- Expanded: unchanged from the original. The <br> only works on raw text nodes;
                       wrapping the values in spans makes them flex items and the break is ignored,
                       which silently collapsed three lines into two. -->
                  @for (v of value; track $index; let i = $index) {
                    {{ v }}
                    @if (i < value.length - 1) {
                      <br>
                    }
                  }
                }
              } @else {
                {{ value }}
              }
            </span>
          </div>
        </button>
        @if(control.key === 'gemstones') {
          <div class="GemstoneRemoveContainer"><button #removeButton [name]="control.key + '-button'" [ngStyle]="getRemoveButtonStyle(control)" (click)="removeGemstones()" mat-button color="warn">Remove</button></div>
        } @else if (control.key === 'design' && canViewStyleImages()) {
          <div class="ViewStyleImagesContainer"><button #viewStyleImagesButton [ngStyle]="getStyleImageViewButtonStyle(control)" (click)="viewStyleImages()" mat-button class="ThemeColorPrimary">View Examples</button></div>
        }
      </div>
    }
    <div #positionIndicator class="PositionIndicator"></div>
  </div>
}
